import { Navigate, useParams, useSearchParams } from 'react-router-dom';

/**
 * Alias /{role}/classroom/live/:sessionId → meeting page.
 * Staff deep links keep host=1 so End class stays available even if Zoom host reclaim fails.
 */
export default function ClassroomLiveSessionRedirect({ role = 'STUDENT' }) {
  const { sessionId } = useParams();
  const [searchParams] = useSearchParams();
  const staff = ['ADMIN', 'MANAGER', 'COACH'].includes(String(role || '').toUpperCase());
  const next = new URLSearchParams(searchParams);
  if (staff && next.get('host') !== '0') {
    next.set('host', '1');
  }
  const qs = next.toString();
  const portal = String(role || 'student').toLowerCase();
  return (
    <Navigate
      to={`/${portal}/classroom/meeting/${sessionId}${qs ? `?${qs}` : ''}`}
      replace
    />
  );
}
